var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-form"},[_c('b-row',{attrs:{"align-h":"between"}},[_c('b-col',{attrs:{"cols":"7"}},[_c('b-form',{attrs:{"onsubmit":"return false"},on:{"reset":_vm.reset}},[_c('b-input-group',{attrs:{"size":"sm"}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }